import EmberObject from '@ember/object';

import * as OpAmpNegCurrent from './noise-sources/op-amp-neg-current';
import * as OpAmpPosCurrent from './noise-sources/op-amp-pos-current';
import * as OpAmpVoltage from './noise-sources/op-amp-voltage';
import * as R1 from './noise-sources/r1';
import * as R2 from './noise-sources/r2';
import * as R5 from './noise-sources/r5';
import FilterConstants from '../../../../filter-constants';

export default class MultipleFeedbackLowPassNoiseSource extends EmberObject {
  r1 = null;
  r2 = null;
  r5 = null;
  c1 = null;
  c2 = null;
  rOut = null;
  frequency = null;
  _r1Noise(filterAmplitude, complexDenominator, complexFFDenominator, sImaginary) {
    var baseAmplitudeCopy = filterAmplitude;
    var r5 = this.r5;
    var c2 = this.c2;
    var r1 = this.r1;
    var r2 = this.r2;
    var rOut = this.rOut;
    var complexAlphaMinus = R1.computeComplexAlphaMinus(complexDenominator, r5);
    var complexFF = R1.computeComplexFF(complexFFDenominator, c2, r2, r5, rOut, sImaginary);
    var value = Math.sqrt(r1 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = baseAmplitudeCopy.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }
  _r2Noise(filterAmplitude, complexDenominator, complexFFDenominator, sImaginary) {
    var c1 = this.c1;
    var c2 = this.c2;
    var r1 = this.r1;
    var r2 = this.r2;
    var r5 = this.r5;
    var rOut = this.rOut;
    var complexAlphaMinus = R2.computeComplexAlphaMinus(complexDenominator, c1, r1, r5, sImaginary);
    var complexFF = R2.computeComplexFF(complexFFDenominator, c1, c2, r1, r5, rOut, sImaginary);
    var value = Math.sqrt(r2 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }
  _r5Noise(filterAmplitude, complexDenominator, complexFFDenominator, sImaginary, sSquared) {
    var c1 = this.c1;
    var c2 = this.c2;
    var r1 = this.r1;
    var r2 = this.r2;
    var r5 = this.r5;
    var rOut = this.rOut;
    var complexAlphaMinus = R5.computeComplexAlphaMinus(complexDenominator, r1);
    var complexFF = R5.computeComplexFF(complexFFDenominator, c1, c2, r1, r2, rOut, sImaginary, sSquared);
    var value = Math.sqrt(r5 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }
  _opAmpNegCurrent(filterAmplitude, complexDenominator, complexFFDenominator, sImaginary, sSquared) {
    var c1 = this.c1;
    var c2 = this.c2;
    var r1 = this.r1;
    var r2 = this.r2;
    var r5 = this.r5;
    var rOut = this.rOut;
    var complexAlphaMinus = OpAmpNegCurrent.computeComplexAlphaMinus(complexDenominator, c1, r1, r2, r5, sImaginary);
    var complexFF = OpAmpNegCurrent.computeComplexFF(
      complexFFDenominator,
      c1,
      c2,
      r1,
      r2,
      r5,
      rOut,
      sImaginary,
      sSquared,
    );
    var value = this.iNoise;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }
  _opAmpPosCurrent(filterAmplitude) {
    var complexAlphaMinus = OpAmpPosCurrent.computeComplexAlphaMinus();
    var complexFF = OpAmpPosCurrent.computeComplexFF();
    var value = +this.iNoise;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }
  _opAmpVoltage(filterAmplitude) {
    var complexAlphaMinus = OpAmpVoltage.computeComplexAlphaMinus();
    var complexFF = OpAmpVoltage.computeComplexFF();
    var value = +this.vNoise;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }
  totalNoise(filterAmplitude, complexDenominator, complexFFDenominator, sImaginary, sSquared) {
    var r1Noise = this._r1Noise(filterAmplitude, complexDenominator, complexFFDenominator, sImaginary);
    var r2Noise = this._r2Noise(filterAmplitude, complexDenominator, complexFFDenominator, sImaginary);
    var r5Noise = this._r5Noise(filterAmplitude, complexDenominator, complexFFDenominator, sImaginary, sSquared);
    var opAmpNegCurrent = this._opAmpNegCurrent(
      filterAmplitude,
      complexDenominator,
      complexFFDenominator,
      sImaginary,
      sSquared,
    );
    var opAmpPosCurrent = this._opAmpPosCurrent(filterAmplitude);
    var opAmpVoltage = this._opAmpVoltage(filterAmplitude);
    var noiseArray = [r1Noise, r2Noise, r5Noise, opAmpNegCurrent, opAmpPosCurrent, opAmpVoltage];
    var sumOfSquares = 0;

    noiseArray.forEach((item) => {
      sumOfSquares += item * item;
    });

    var result = Math.sqrt(sumOfSquares);
    return result;
  }
}
